import { Dialog } from "@ark-ui/react"
import type React from "react"

import { CloseIcon } from "../Icon"

const ModalHeader = ({
  title,
  close,
}: {
  title?: React.ReactNode
  close?: () => void
}) => {
  if (!title && !close) return null

  return (
    <div className="cobalt-modal-header">
      <Dialog.Title className="cobalt-modal-header__title">
        {title}
      </Dialog.Title>
      {close && (
        <button
          type="button"
          className="cobalt-modal-header__close-button"
          onClick={close}
        >
          <span aria-hidden>
            <CloseIcon color="onSurfaceVariant" />
          </span>
        </button>
      )}
    </div>
  )
}

export default ModalHeader
